function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.925 155.664l51.634-30.003 35.597-61.705V4.462c-.939 0-1.878.619-2.59 1.85L61.4 79.406 19.24 152.499c-.711 1.233-.779 2.352-.314 3.165",
  fill: "#FF4724"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.156 4.462v59.494l35.595 61.705 51.634 30.003c.466-.813.399-1.932-.312-3.165L150.91 79.406 108.745 6.312c-.713-1.233-1.652-1.85-2.589-1.85",
  fill: "#9E1F63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.385 155.664l-51.634-30.003H70.56l-51.634 30.003c.465.817 1.466 1.324 2.891 1.324h168.675c1.425 0 2.426-.507 2.893-1.324",
  fill: "#662D91"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.56 125.661h71.191l-35.595-61.705L70.56 125.66z",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.323,
  y: 0.8,
  width: 211.665,
  height: 189.139,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 14.645
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9.153
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgBatLogo = function SvgBatLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 212 190",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBatLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bat-logo.60d948a9.svg";
export { ForwardRef as ReactComponent };